const API_BASE = process.env.REACT_APP_API_URL || "/api";

function getToken() {
  return localStorage.getItem("nexuscrm_token");
}

export function setToken(token) {
  if (token) localStorage.setItem("nexuscrm_token", token);
  else localStorage.removeItem("nexuscrm_token");
}

export function isAuthenticated() {
  return !!getToken();
}

async function request(method, path, body) {
  const headers = { "Content-Type": "application/json" };
  const token = getToken();
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  if (res.status === 401) {
    setToken(null);
    window.location.reload();
    throw new Error("Session expired");
  }

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Request failed");
  return data;
}

// ── Auth ────────────────────────────────────────────────────────────────────────
export const auth = {
  register: (email, password, fullName) =>
    request("POST", "/auth/register", { email, password, fullName }),
  login: (email, password, totpCode) =>
    request("POST", "/auth/login", { email, password, totpCode }),
  me: () => request("GET", "/auth/me"),
  changePassword: (currentPassword, newPassword) =>
    request("POST", "/auth/change-password", { currentPassword, newPassword }),
  setup2FA: () => request("POST", "/auth/2fa/setup"),
  verify2FA: (code) => request("POST", "/auth/2fa/verify", { code }),
  disable2FA: (password) => request("POST", "/auth/2fa/disable", { password }),
};

// ── Contacts ────────────────────────────────────────────────────────────────────
export const contacts = {
  list: (params) => {
    const qs = new URLSearchParams(params).toString();
    return request("GET", `/contacts${qs ? `?${qs}` : ""}`);
  },
  get: (id) => request("GET", `/contacts/${id}`),
  create: (data) => request("POST", "/contacts", data),
  update: (id, data) => request("PUT", `/contacts/${id}`, data),
  delete: (id) => request("DELETE", `/contacts/${id}`),
};

// ── Deals ───────────────────────────────────────────────────────────────────────
export const deals = {
  list: (params) => {
    const qs = new URLSearchParams(params || {}).toString();
    return request("GET", `/deals${qs ? `?${qs}` : ""}`);
  },
  get: (id) => request("GET", `/deals/${id}`),
  create: (data) => request("POST", "/deals", data),
  update: (id, data) => request("PUT", `/deals/${id}`, data),
  moveStage: (id, stage) => request("PATCH", `/deals/${id}/stage`, { stage }),
  delete: (id) => request("DELETE", `/deals/${id}`),
  pipelineStats: () => request("GET", "/deals/stats/pipeline"),
};

// ── Tasks ───────────────────────────────────────────────────────────────────────
export const tasks = {
  list: (params) => {
    const qs = new URLSearchParams(params || {}).toString();
    return request("GET", `/tasks${qs ? `?${qs}` : ""}`);
  },
  create: (data) => request("POST", "/tasks", data),
  update: (id, data) => request("PUT", `/tasks/${id}`, data),
  toggle: (id) => request("PATCH", `/tasks/${id}/toggle`),
  delete: (id) => request("DELETE", `/tasks/${id}`),
};
// — Schedule (Calendar) ------------------------------------------------------
// Add this block to frontend/src/api.js, alongside the existing
// `export const tasks = {...}` etc. It reuses the same `request()` helper.
export const schedule = {
  list: (params) => {
    const qs = new URLSearchParams(params || {}).toString();
    return request("GET", `/schedule${qs ? `?${qs}` : ""}`);
  },
  get: (id) => request("GET", `/schedule/${id}`),
  create: (data) => request("POST", "/schedule", data),
  update: (id, data) => request("PUT", `/schedule/${id}`, data),
  move: (id, data) => request("PATCH", `/schedule/${id}/move`, data),
  delete: (id) => request("DELETE", `/schedule/${id}`),
};
